exports.hasClass = (el, className) => {
  let classes = el.className.split(' ')
  for (let i = 0; i < classes.length; i++) {
    if (classes[i] === className) return true
  }
  return false
}

exports.hasRole = (user, role) => {
  if (Array.isArray(role)) {
    for (let i = 0; i < user.roles.length; i++) {
      for (let j = 0; j < role.length; j++) {
        if (user.roles[i] === role[j]) return true
      }
    }
  } else {
    for (let i = 0; i < user.roles.length; i++) {
      if (user.roles[i] === role) return true
    }
  }
  return false
}

exports.inArray = (value, arr, field) => {
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      if (field != null && arr[i][field] === value) return true
      else if (arr[i] === value) return true
    }
  }
  return false
}
